"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.APIKeyAuthType = exports.OAuthAuthType = exports.MicrosoftEntraAuthType = exports.TelemetryProperty = exports.lifecycleExecutionEvent = exports.component = exports.SummaryConstant = void 0;
/**
 * @author yefuwang@microsoft.com
 */
var SummaryConstant;
(function (SummaryConstant) {
    SummaryConstant["Succeeded"] = "(\u221A) Done:";
    SummaryConstant["Failed"] = "(\u00D7) Error:";
    SummaryConstant["NotExecuted"] = "(!) Warning:";
    SummaryConstant["Warning"] = "(!) Warning:";
    SummaryConstant["Info"] = "(i) Info:";
})(SummaryConstant || (exports.SummaryConstant = SummaryConstant = {}));
exports.component = "ConfigManager";
exports.lifecycleExecutionEvent = "lifecycle-execution";
var TelemetryProperty;
(function (TelemetryProperty) {
    TelemetryProperty["Lifecycle"] = "lifecycle";
    TelemetryProperty["Actions"] = "actions";
    TelemetryProperty["ResolvedPlaceholders"] = "resolved";
    TelemetryProperty["UnresolvedPlaceholders"] = "unresolved";
    TelemetryProperty["FailedAction"] = "failed-action";
})(TelemetryProperty || (exports.TelemetryProperty = TelemetryProperty = {}));
exports.MicrosoftEntraAuthType = "MicrosoftEntra";
exports.OAuthAuthType = "OAuthPluginVault";
exports.APIKeyAuthType = "ApiKeyPluginVault";
//# sourceMappingURL=constant.js.map